export const patientListVariants = {
  ACTIVE: "active",
  ARCHIVED: "archived",
  FLAGGED: "flagged",
  ALERTS: "alerts",
};
